import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

// Default timeout for most requests
const DEFAULT_TIMEOUT = 30000; // 30 seconds

// Extended timeout for AI generation endpoints (5 minutes)
const EXTENDED_TIMEOUT = 300000; // 5 minutes

const api = axios.create({
  baseURL: API_URL,
  timeout: DEFAULT_TIMEOUT,
});

// Endpoints that require extended timeout (AI generation)
const LONG_RUNNING_ENDPOINTS = [
  '/generate-qa-pack',
  '/regenerate-qa-pack',
];

// Add token to requests and adjust timeout for long-running operations
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Check if this is a long-running endpoint
  const isLongRunning = LONG_RUNNING_ENDPOINTS.some(endpoint => 
    config.url?.includes(endpoint)
  );
  
  if (isLongRunning) {
    config.timeout = EXTENDED_TIMEOUT;
  }
  
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't redirect on 401 for login/signup endpoints - let the component handle it
    const isAuthEndpoint = error.config?.url?.includes('/auth/login') || 
                           error.config?.url?.includes('/auth/signup');
    
    if (error.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

// Lightweight, fire-and-forget funnel event tracker.
// Safe to call without await; never throws.
// Anonymous events are de-duplicated per browser session to neutralize React 18 StrictMode double-effects.
const _funnelSentInSession = new Set();
const ANON_EVENTS_DEDUPE = new Set(['landing_visit', 'pricing_viewed']);

export const trackFunnel = (event, metadata) => {
  try {
    // Per-session dedupe key for anonymous, page-mount events (path-aware where useful)
    if (ANON_EVENTS_DEDUPE.has(event)) {
      const key = `${event}:${(metadata && metadata.page) || ''}`;
      if (_funnelSentInSession.has(key)) return;
      _funnelSentInSession.add(key);
    }
    const vid = localStorage.getItem('tg_vid') || null;
    const token = localStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    fetch(`${BACKEND_URL}/api/funnel/track`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ event, visitor_id: vid, metadata: metadata || null }),
    }).catch(() => {});
  } catch { /* never break the UI */ }
};
